module.exports = __webpack_public_path__ + "img/faq1.58bd1c3a.svg";